module.exports = __webpack_public_path__ + "img/welcomes-icon-1.2738d8be.png";